module.exports = __webpack_public_path__ + "static/media/personal-data.8590971b.docx";